
import WhiteListPage from './whitelistpage'

export default WhiteListPage;